import { render } from "./ComentCard.vue?vue&type=template&id=5f0ed26c&scoped=true"
import script from "./ComentCard.vue?vue&type=script&lang=js"
export * from "./ComentCard.vue?vue&type=script&lang=js"

import "./ComentCard.vue?vue&type=style&index=0&id=5f0ed26c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0ed26c"]])

export default __exports__